<template>
  <v-dialog v-model="value" width="800">
    <v-card>
      <v-card-title class="text-h5 primary white--text d-flex flex-nowrap justify-space-between align-center">
        {{ $t('guide.adminRegistered.title') }}
        <v-btn icon dark @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-4">
        <div class="black--text text-body-1 mb-2">
          <h6 class="text-h6 mb-3">{{ $t('guide.adminRegistered.nextStep') }}</h6>
          <p>{{ $t('guide.adminRegistered.description') }}</p>
        </div>
        <v-checkbox v-model="hideDialogInFuture" :label="$t('guide.dontShowAgain')"></v-checkbox>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn outlined color="primary" @click="closeDialog">{{ $t('dueDiligence.close') }}</v-btn>
        <v-btn depressed color="primary" :to="{ name: 'ActivationKeyList' }">{{ $t('guide.start') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      hideDialogInFuture: false,
    };
  },

  methods: {
    closeDialog() {
      if (this.hideDialogInFuture) {
        localStorage.setItem('hideGuideOnAdminRegister', 'true');
      }
      this.$emit('input', false);
    },
  },
};
</script>
